<template>
    <div class="videos">
        <template v-if="videos.list.length">
            <div class="large">
                <ChatVideoPlay :videos="[videos.list[videos.active][0], videos.list[videos.active][1]]"
                    :video-index="videos.active" />
            </div>
            <div class="thumbnails">
                <div class="item" :class="{ active: videos.active === index }" v-for="(item, index) in videos.list"
                    :key="`${item}-${index}`" @click="onVideoChange(index)">
                    <video width="100%" height="100%">
                        <source :src="item[0]" type="video/mp4" />
                        <source :src="item[0]" type="video/ogg" />
                        <span>您的浏览器不支持 HTML5 video 标签。</span>
                    </video>
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                                d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-48-247.616L668.608 512 464 375.616zm10.624-342.656 249.472 166.336a48 48 0 0 1 0 79.872L474.624 718.272A48 48 0 0 1 400 678.336V345.6a48 48 0 0 1 74.624-39.936z">
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="videos.loading">
            <van-loading />
        </template>
        <van-empty v-else description="暂无视频" />
    </div>
</template>

<script>
import ChatVideoPlay from '@/components/chat/video/play.vue'
import api from '@/utils/request'

export default {
    components: {
        ChatVideoPlay
    },
    data() {
        return {
            videos: {
                active: 0,
                loading: false,
                list: []
            }
        }
    },
    mounted() {
        this.onDataGet()
    },
    methods: {
        async onDataGet() {
            this.videos.loading = true
            try {
                const { data } = await api({
                    method: 'get',
                    url: `/user-service/askRecording/getAskVideo/${this.$route.query.askNo}`
                })
                this.videos.list = this.onDataInit(data)
            } catch (error) {

            }
            this.videos.loading = false
        },
        onDataInit(objs) {
            const res = []
            for (const k in objs) {
                const row = []
                for (const v in objs[k]) {
                    if (v.includes('YS')) {
                        row.push(objs[k][v])
                    } else {
                        row.unshift(objs[k][v])
                    }
                    if (row.length === 2) {
                        break
                    }
                }
                if (row.length) {
                    res.push(row)
                }
            }
            return res
        },
        onVideoChange(index) {
            if (this.videos.active === index) return false
            this.videos.active = index
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/base";

.videos {
    flex: 1;
    @include flex($dir: column);

    .large {
        flex: 1;
        background: #282828;
    }

    .thumbnails {
        display: flex;
        gap: 15px;
        flex: none;
        background: #f2f2f2;
        overflow-x: auto;
        padding: 15px;

        .item {
            position: relative;
            flex: none;
            width: 90px;
            height: 90px;
            border: 3px solid transparent;
            box-sizing: boder-box;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;

            .icon {
                position: absolute;
                inset: 0;
                background: rgba(#000, 0.25);
                @include flex(center, center);
                color: rgba(#000, 0.5);
                font-weight: bold;

                svg {
                    width: 40px;
                    height: 40px;
                }
            }

            &.active {
                border-color: $color-primary;
            }
        }
    }

    .van-loading {
        @include flex(center, center);
    }
}
</style>